import { TableCell } from "@material-ui/core";
import { formatNumber, isNull } from "App/utils/helpers";

export default function FieldTarif({ dataTarif, row, withHargaBeli = true }) {
  return dataTarif.map((e, index) => {
    let harga = Array.isArray(row.harga) ? row.harga : [];
    const kelas = harga.find(({ id_tarif }) => id_tarif === e.id);

    return (
      <TableCell key={`tarif-${index}`} align='left'>
        <table width='100%'>
          <tbody>
            {withHargaBeli && (
              <tr>
                <td>Harga Beli</td>
                <td style={{ padding: "0 10px" }}>:</td>
                <td>{isNull(kelas) ? 0 : formatNumber(kelas.harga_beli)}</td>
              </tr>
            )}
            <tr>
              <td>Harga Jual</td>
              <td style={{ padding: "0 10px" }}>:</td>
              <td>{isNull(kelas) ? 0 : formatNumber(kelas.harga_jual)}</td>
            </tr>
          </tbody>
        </table>
      </TableCell>
    );
  });
}
